import { observer } from 'mobx-react-lite'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { useNewInboxStepsContext } from 'pages/settings/pages/inboxes/pages/newInbox/context/newInboxStepsContext'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { CommonNumbers } from 'pages/settings/pages/compliance/ui/CommonNumbers/CommonNumbers'

export const AddSalesmsgNumbers = observer(() => {
  const {
    commonStore: { unassignedNumbersCount },
    addSalesmsgNumbersStore,
    stepLoading,
  } = useNewInboxStepsContext()
  const { loading, numbersStore, nextClickHandler } = addSalesmsgNumbersStore

  return (
    <div>
      <PageDescription>
        Your workspace has {unassignedNumbersCount} unassigned number
        {unassignedNumbersCount > 1 ? 's' : ''} available
      </PageDescription>

      <CommonNumbers loading={loading} numbersStore={numbersStore} isLabelQuestionTooltip={false} />

      <NextButton
        loading={stepLoading}
        disabled={numbersStore.isStepDisabled || stepLoading}
        text='Create inbox'
        onClick={nextClickHandler}
      />
    </div>
  )
})
